angular.module('clients')
    .component('clientTasks', {
        bindings: {
            clientId: '<',
            onDataLoaded: '&',
        },
        templateUrl: 'app/clients/client-tasks.html',
        controller: function($scope, Document, ClientConst) {
            this.$onChanges = () => {
                this.filters = {id: this.clientId};
                this.loadData();
            };

            this.loadData = () => {
                if(this.clientId == null) {
                    this.page = emptyPage();
                    if (angular.isFunction(this.onDataLoaded)) {
                        this.onDataLoaded({$page: this.page});
                    }
                    return;
                }
                Document.table(this.filters).$promise.then(result => {
                    this.page = result;
                    if (angular.isFunction(this.onDataLoaded)) {
                        this.onDataLoaded({$page: this.page});
                    }
                })
            };

            $scope.$on(ClientConst.eventUpdate, () => this.loadData())
            $scope.$on('task.updated', () => this.loadData());
            $scope.$on('task.deleted', () => this.loadData());
            $scope.$on('note.updated', () => this.loadData());
            $scope.$on('note.deleted', () => this.loadData());

            function emptyPage() {
                return {
                    list: [],
                    fullListSize: 0,
                    objectsPerPage: 0,
                    pageNumber: 1
                };
            }
        }
    })
